import axios from 'axios';
import constants from '../constants';
import { EmailDetails } from '../types'

export const sendEmail = async (emailDetails: EmailDetails, customerNumber: string) => {
  return await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/notifications/send-email`, emailDetails );
};
